export const CHEGG_LAYOUT_HEADER = 'chegg-layout-header'
